var _rect, _rect2, _rect3, _path, _rect4, _path2, _rect5, _path3, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.00659,
    y: 0.000358582,
    width: 4.01307,
    height: 20.0654,
    rx: 2.00654,
    fill: "black",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0361,
    y: 12.0394,
    width: 4.01307,
    height: 20.0654,
    rx: 2.00654,
    fill: "black",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.0654,
    y: 0.000358582,
    width: 4.01307,
    height: 20.0654,
    rx: 2.00654,
    fill: "black",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0654 26.0852H24.0785V30.0983C24.0785 31.2064 23.1801 32.1048 22.072 32.1048C20.9638 32.1048 20.0654 31.2064 20.0654 30.0983V26.0852Z",
    fill: "black",
    fillOpacity: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.085,
    y: 22.0721,
    width: 4.01307,
    height: 8.02614,
    rx: 2.00654,
    transform: "rotate(90 26.085 22.0721)",
    fill: "black",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0361 6.01984H15.0492V2.00677C15.0492 0.898589 14.1508 0.000232697 13.0427 0.000232697C11.9345 0.000232697 11.0361 0.898589 11.0361 2.00677V6.01984Z",
    fill: "black",
    fillOpacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.01307,
    height: 8.02614,
    rx: 2.00654,
    transform: "matrix(-4.34573e-08 -1 -1 4.3967e-08 17.0557 10.0329)",
    fill: "black",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00659 26.0852H6.01966V30.0983C6.01966 31.2064 5.12131 32.1048 4.01313 32.1048C2.90495 32.1048 2.00659 31.2064 2.00659 30.0983V26.0852Z",
    fill: "black",
    fillOpacity: 0.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.02612,
    y: 22.0721,
    width: 4.01307,
    height: 8.02614,
    rx: 2.00654,
    transform: "rotate(90 8.02612 22.0721)",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuning);
export default __webpack_public_path__ + "static/media/tuning.98be036c985e90eab382e332bfda1c68.svg";
export { ForwardRef as ReactComponent };